module.exports = __webpack_public_path__ + "static/media/renaming-poster.a827be3e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Media/posterImgs/renaming-poster.jpg
// module id = 421
// module chunks = 0